import { render, staticRenderFns } from "./metas.vue?vue&type=template&id=2104cba8&scoped=true"
import script from "./metas.vue?vue&type=script&lang=js"
export * from "./metas.vue?vue&type=script&lang=js"
import style0 from "./metas.vue?vue&type=style&index=0&id=2104cba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104cba8",
  null
  
)

export default component.exports